import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
  Typography
} from '@mui/material';
// import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
// import ROUTE from 'src/utils/routeConstants';
import Loader from 'src/common/Loader';
import { getVehicleRecordList } from 'src/redux/vehicleSlice';
import EnhancedTableHead, { getComparator } from 'src/common/EnhancedTableHead';
import { vehicleRecordTableHeaders } from 'src/utils/tableHeaders';
import {
  formatNumber,
  getFormattedDate,
  getSelectedSiteFilterValue
} from 'src/utils/getInitials';
import { DATE_FORMAT, TABLE_ROWS_PER_PAGE } from 'src/utils/constants';

const VehicleRecordTable = ({
  refreshData, searchText, siteFilter, ...rest
}) => {
  // const history = useHistory();
  const dispatch = useDispatch();
  const { vehicleRecordList, loading, totalCount } = useSelector((state) => state.vehicles);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('registration_num');
  const selectedSite = getSelectedSiteFilterValue(siteFilter);

  useEffect(() => {
    setPage(0);
    dispatch(getVehicleRecordList({
      limit,
      pageNo: 1,
      params: { registration_num: searchText, site: selectedSite }
    }));
  }, [dispatch, limit, refreshData, searchText, selectedSite]);

  const handleLimitChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    setPage(0);
    setLimit(newLimit);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    dispatch(getVehicleRecordList({
      limit,
      pageNo: newPage + 1,
      params: { registration_num: searchText, site: selectedSite }
    }));
  };

  // const viewVehicleInfo = (vehicleId) => {
  //   history.push(`${ROUTE.vehicles}/${vehicleId}`);
  // };

  const handleRequestSort = (e, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Card {...rest}>
          <PerfectScrollbar>
            <Box sx={{ minWidth: { xs: 760, sm: 900, md: 1050 } }}>
              <Table>
                <EnhancedTableHead
                  order={order}
                  orderBy={orderBy}
                  headCells={vehicleRecordTableHeaders}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {vehicleRecordList
                    .slice()
                    .sort(getComparator(order, orderBy))
                    // .slice(page * limit, page * limit + limit)
                    .map((vehicle) => (
                      <TableRow hover key={vehicle.id}>
                        <TableCell>
                          <Box sx={{ alignItems: 'center', display: 'flex' }}>
                            <Typography color="textPrimary" variant="body1">
                              {vehicle.registration_num}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>{vehicle.shift || 'NA'}</TableCell>
                        <TableCell>{getFormattedDate(vehicle.date, DATE_FORMAT.date)}</TableCell>
                        <TableCell>{formatNumber(vehicle.opening_reading)}</TableCell>
                        <TableCell>{formatNumber(vehicle.closing_reading)}</TableCell>
                        <TableCell>{formatNumber(vehicle.running_hours)}</TableCell>
                        <TableCell>{vehicle.number_of_trips}</TableCell>
                        <TableCell>{formatNumber(vehicle.quantity)}</TableCell>
                        <TableCell>{formatNumber(vehicle.hsd)}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </Box>
          </PerfectScrollbar>
          <TablePagination
            component="div"
            showFirstButton
            showLastButton
            count={totalCount}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={TABLE_ROWS_PER_PAGE}
          />
        </Card>
      )}
    </>
  );
};

VehicleRecordTable.propTypes = {
  refreshData: PropTypes.bool,
  searchText: PropTypes.string,
  siteFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default VehicleRecordTable;
